// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// JavaScript
import * as ActiveStorage from '@rails/activestorage'
import Rails from '@rails/ujs'
import 'bootstrap'
import 'packs/preview'
import 'packs/point'
import 'packs/initialize-swiper'

// CSS
import 'stylesheets/application'

Rails.start()
ActiveStorage.start()

// Asset
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
